module.exports = __webpack_public_path__ + "static/media/Retail.5096cabb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/Industries/Retail.svg
// module id = 323
// module chunks = 0